import { useApi } from "../../../hooks/useApi";
import { useCallback } from "react";
import { ApiRoutes } from "../../../constants/apiRoutes";
import { EducationType } from "../../school/constants/types";

export default function () {
  const { request } = useApi();

  return {
    createReceipt: useCallback(
      async (data, educationType, id) => {
        const getUrl = (educationType: EducationType): string => {
          switch (educationType) {
            case EducationType.Language:
              return ApiRoutes.BILLING_LANGUAGE_COURSE;
            case EducationType.Secondary:
              return ApiRoutes.BILLING_SECONDARY;
            case EducationType.Higher:
              return ApiRoutes.BILLING_HIGHER;
            default:
              return "";
          }
        };

        return request({
          data,
          method: "POST",
          url: getUrl(educationType),
        });
      },
      [request],
    ),
    uploadReceiptImage: useCallback(
      (file) => {
        let formData = new FormData();
        formData.append("file", file);
        return request({
          method: "POST",
          url: `${ApiRoutes.UPLOAD_BILLING_RECEIPT_IMAGE}`,
          data: formData,
        });
      },
      [request],
    ),
  };
}
